import React from "react";
import Header from "../components/header/header";
import "../home/home.scss";

const Pricing = () => {
    return (
        <div className="home-container">
            <div className="header-component">
                <Header />
            </div>
            <div className="price-banner-bx">
                <div className="price-banner"> </div>
                <div className="container">
                    <div className="price-bnr-cntnt col-sm-5">
                        <h1>Pricing & Plans</h1>
                        <p>
                            Most Health Insurance Plans are Accepted
                        </p>
                        <div className="wthot-insu">
                            <h3>Rate Without Insurance</h3>
                            <h4>INITIAL VISIT:</h4>
                            <div className="rate"><span className="rate-head">Doctors:</span>  $300</div>
                            <div className="rate"><span className="rate-head">NP/PA:</span> $200</div>
                            <div className="rate"><span className="rate-head">Therapist:</span> $100</div><br />

                            <h4>FOLLOW UP VISITS:</h4>
                            <div className="rate"><span className="rate-head">Doctors:</span> $100</div>
                            <div className="rate"><span className="rate-head">NP/PA:</span> $100</div>
                            <div className="rate"><span className="rate-head">Therapist:</span> $100</div>
                            <a href="#" className="bk-apint-txt">Book an Appointment</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container price-tabs">
                <div className="row row-eq-height">
                    <div className="col">
                        <div className="urgent-care-tab">
                            <header>Psychiatry Adult</header>
                            <h5>Initial/Follow Up Rates</h5>
                            <div className="rate"><span className="rate-head">Doctors:</span> $300<span className="slash">/</span>$100</div>
                            <div className="rate"><span className="rate-head">NP/PA:</span> $200<span className="slash">/</span>$100</div>
                            <div className="row">
                                <div className="col">
                                    <ul>
                                        <li>Depression</li>
                                        <li>Anxiety</li>
                                        <li>Sleep Disorders</li>
                                        <li>Panic Disorders</li>
                                        <li>Eating Disorders</li>
                                        <li>OCD</li>
                                    </ul>
                                </div>
                                <div className="col">
                                    <ul>
                                        <li>ADHD</li>
                                        <li>Bipolar Disorder</li>
                                        <li>Consultations</li>
                                        <li>Meds Renewals</li>
                                        <li>2nd Opinions</li>
                                        <li>Many more...</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="price-act"><a href="https://consumer.scheduling.athena.io/?locationId=20729-1&practitionerId=20729-1" className="button pri-button">Get Started</a></div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="psychiatry-tab ps-child">
                            <header>Psychiatry Child</header>
                            <h5>Initial/Follow Up Rates</h5>
                            <div className="rate"><span className="rate-head">MD:</span> $300<span className="slash">/</span>$100</div>
                            <div className="rate"><span className="rate-head">NP/PA:</span> $200<span className="slash">/</span>$100</div>
                            <div className="row">
                                <div className="col">
                                    <ul>
                                        <li>Depression</li>
                                        <li>Panic Disorders</li>
                                        <li>Behavior Problems</li>
                                        <li>School Problems</li>
                                        <li>Aggression</li>
                                        <li>Many more...</li>
                                    </ul>
                                </div>
                                <div className="col">
                                    <ul>
                                        <li>ADHD</li>
                                        <li>Anxiety</li>
                                        <li>Bipolar Disorder</li>
                                        <li>Grief Issues</li>
                                        <li>OCD</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="price-act"><a href="https://consumer.scheduling.athena.io/?locationId=20729-1&practitionerId=20729-1" className="button pri-button">Get Started</a></div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="counseling-tab adult-tab">
                            <header>ADULT THERAPY</header>
                            <div className="rate"><span className="rate-head">Therapist:</span> $100</div>
                            <div className="row">
                                <div className="col">
                                    <ul>
                                        <li>Stress</li>
                                        <li>Anxiety</li>
                                        <li>Depression</li>
                                        <li>Sleep Disorders</li>
                                        <li>PTSD</li>
                                        <li>OCD</li>
                                    </ul>
                                </div>
                                <div className="col">
                                    <ul>
                                        <li>Self-Esteem</li>
                                        <li>Body Dysmorphia</li>
                                        <li>Relationships</li>
                                        <li>Grief</li>
                                        <li>Anger</li>
                                        <li>2nd Opinions</li>
                                        <li>Many more...</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="price-act"><br /><a style={{ marginTop: 8 }} href="https://consumer.scheduling.athena.io/?locationId=20729-1&practitionerId=20729-1" className="button pri-button">Get Started</a></div>
                        </div>
                    </div>
                </div>
                <div className="row row-eq-height">
                    <div className="col">
                        <div className="urgent-care-tab">
                            <header>Teen Counseling</header>
                            <div className="rate"><span className="rate-head">Therapist:</span> $100</div>
                            <div className="row">
                                <div className="col">
                                    <ul>
                                        <li>ADHD</li>
                                        <li>Aggression</li>
                                        <li>Behavior Problems</li>
                                        <li>School Problems</li>
                                        <li>Acting Out</li>
                                        <li>Many more...</li>
                                    </ul>
                                </div>
                                <div className="col">
                                    <ul>
                                        <li>Depression</li>
                                        <li>Anxiety</li>
                                        <li>Bipolar Disorder</li>
                                        <li>Grief</li>
                                        <li>2nd Opinions</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="price-act"><br /><a href="#" className="button pri-button">Get Started</a></div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="psychiatry-tab intake">
                            <header>Intake Assessment</header>
                            <div className="rate" style={{ marginBottom: 10 }}><span className="rate-head">Fee:</span> $99</div>
                            <h5>If you are not sure of what type of services you should obtain, an Intake Assessor can help you with this one time assessment.</h5>
                            <div className="price-act"><br /><br /><br /><br /><br /><a style={{ marginTop: 10 }} href="#" className="button pri-button">Get Started</a></div>
                        </div>
                    </div>
                    <div className="col card-col"></div>
                </div>
            </div>
        </div>
    );
};

export default Pricing;
